import { IExamCategoryModel, ExamCategoryModel } from '@common/models';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceHelper } from '../serviceHelper';
import { ServiceMethodOptions } from '../types';

export class ExamCategoryService {
  private static baseUrl: string = '/api/examCategory';

  static tags = {
    examCategories: 'examCategories',
    getExamCategory: 'getExamCategory',
    upsertExamCategory: 'upsertExamCategory',
    deleteExamCategory: 'deleteExamCategory',
  };

  static getExamCategoryById = (
    id: number,
    options?: ServiceMethodOptions,
  ): Promise<ExamCategoryModel> => {
    return trackPromise(
      new Promise<ExamCategoryModel>((resolve, reject) => {
        http(`${this.baseUrl}/${id}`)
          .get<IExamCategoryModel>()
          .then((response) => {
            ServiceHelper.showSuccess('Exam Category fetched.', options);
            resolve(new ExamCategoryModel(response));
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to get Exam Category.', options);
            reject(err);
          });
      }),
      this.tags.getExamCategory,
    );
  };

  static upsertExamCategory = (
    data: IExamCategoryModel,
    options?: ServiceMethodOptions,
  ): Promise<ExamCategoryModel> => {
    return trackPromise(
      new Promise<ExamCategoryModel>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .post<IExamCategoryModel>(data)
          .then((response) => {
            ServiceHelper.showSuccess('Exam Category updated.', options);
            resolve(new ExamCategoryModel(response));
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to update Exam Category.', options);
            reject(err);
          });
      }),
      this.tags.upsertExamCategory,
    );
  };

  static deleteExamCategory = (
    id: number,
    options?: ServiceMethodOptions,
  ): Promise<boolean> => {
    return trackPromise(
      new Promise<boolean>((resolve, reject) => {
        http(`${this.baseUrl}/${id}`)
          .delete()
          .then(() => {
            ServiceHelper.showSuccess(
              'Exam Category has been deleted.',
              options,
            );
            resolve(true);
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to delete Exam Category.', options);
            reject(err);
          });
      }),
      this.tags.deleteExamCategory,
    );
  };
}
